module.exports = __webpack_public_path__ + "img/btn-part-10-sendbtn.cfe9be31.png";